import React, { useState, useEffect, useRef } from 'react';

import api from "../../../services/api";
import { store } from "react-notifications-component";

import Button from '../../button/button_v2';
import Contracts from '../../arts/contracts';

import SelectV2 from "../../select/select_v2";
import SelectV2Multi from "../../select/select_v2_multi";
import Modal from '../../modal/modalGeneric';
import ModalFarmCoords from '../../modal/modalFarmCoords';
import AddProdutor from '../../../pages/produtores/add';
import AddDevolucao from '../../../pages/devolucoes/add';
import AddFazenda from '../../../pages/produtores/addlocal';
import EditLocal from '../../../pages/produtores/editLocal';

import Pin from '../../../assets/icons/icons-8-marker@3x.png';

import * as S from './styles';
import { Footer, ContainerModal, ButtonPlans } from './styles';
import { TaglineP, Auxiliar, BodyG, BodyGSpan, BodyM, H5 } from '../../../styles/stylesTypography';
import { theme } from '../../../styles/theme';
import { isTotvs, isOmie } from '../../../services/globalFunctions';

import identifyErrorMenssage from "../../../services/identifyErrorMenssage";
function FormLocalAplicacao({ ...props }) {
    const [existParams, setExistParams] = useState(false);

    // Controla execução única do prefill para cada select
    const prefillOnce = useRef({ produtor: false, fazenda: false, devolucao: false });
    const isFirstEstadoRender = useRef(true);

    const [produtor, setProdutor] = useState('');
    const [produtores, setProdutores] = useState([]);
    const [disabledProdutor, setDisabledProdutor] = useState(false);
    const [erroProdutor, setErroProdutor] = useState(false);
    const [msgErroProdutor, setMsgErroProdutor] = useState('');
    const [showModalAddProdutor, setShowModalAddProdutor] = useState(false);
    const [loadingProdutor, setLoadingProdutor] = useState(false);

    const [fazenda, setFazenda] = useState('');
    const [fazendas, setFazendas] = useState([]);
    const [disabledFazenda, setDisabledFazenda] = useState(false);
    const [erroFazenda, setErroFazenda] = useState(false);
    const [msgErroFazenda, setMsgErroFazenda] = useState('');
    const [showModalAddFazenda, setShowModalAddFazenda] = useState(false);
    const [loadingFazenda, setLoadingFazenda] = useState(false);

    const [devolucao, setDevolucao] = useState('');
    const [devolucoes, setDevolucoes] = useState([]);
    const [disabledDevolucao, setDisabledDevolucao] = useState(false);
    const [erroDevolucao, setErroDevolucao] = useState(false);
    const [msgErroDevolucao, setMsgErroDevolucao] = useState('');
    const [showModalAddDevolucao, setShowModalAddDevolucao] = useState(false);
    const [loadingDevolucao, setLoadingDevolucao] = useState(false);
    const [showModalFazenda, setShowModalFazenda] = useState(false);
    const [showModalFarmCoords, setShowModalFarmCoords] = useState(false);
    const farmCoordsValidationRef = useRef(0);
    const pendingFarmCoordsRecheckAfterEditRef = useRef(false);
    const showModalFazendaRef = useRef(false);

    const [showModalAddContrato, setShowModalAddContrato] = useState(false);

    const [responsavel, setResponsavel] = useState('');
    const [crea, setCrea] = useState('');
    const [art, setArt] = useState('');
    const [erroArt, setErroArt] = useState(false);

    const [load, setLoad] = useState(false);

     const hasRecipeDraft = !!(props?.recipeDraft && Object.keys(props.recipeDraft).length > 0);

    const PRODUTOR_FAZENDA_STORAGE_KEY = '@agroreceita_produtor_fazenda';

    const persistProdutorFazenda = (nextProdutor, nextFazenda) => {
        if (!nextProdutor?.value || !nextFazenda?.value) {
            localStorage.removeItem(PRODUTOR_FAZENDA_STORAGE_KEY);
            return;
        }

        const payload = {
            produtor: {
                id: nextProdutor.value,
                label: nextProdutor.label,
                cpf_cnpj: nextProdutor.cpf_cnpj || null,
                estado: nextProdutor.estado || null,
                fazenda: {
                    id: nextFazenda.value,
                    label: nextFazenda.label,
                },
            },
        };

        localStorage.setItem(PRODUTOR_FAZENDA_STORAGE_KEY, JSON.stringify(payload));
    };

    // const changeResponsavel = (value) => {
    //     if (value !== responsavel) {
    //         setCrea('');
    //         setArt('');
    //         setResponsavel(value);
    //     } else {
    //     }
    // }

    const updateModalAddContrato = () => {
        setShowModalAddContrato(false);

        setErroArt(false);
        validaCertificadoArt(props.art.value);

        getProdutores(false);
    }

    const validaCertificadoArt = async (artId) => {
        try {
            const response = await api.get(`/arts/${artId}`);
            if (props.estado.value === 'SP') {
                if (crea.estado === 'SP') {
                    if (response.data.data.contratos.length === 0) {
                        setErroArt(true);

                        store.addNotification({
                            title: "Erro!",
                            message: `A ART selecionada não possui nenhum contrato ativo!`,
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 4000,
                                onScreen: true
                            }
                        });
                    }
                }
            }
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }

    const changeProdutor = (value) => {
        if (!value) {
            setErroProdutor(false);
            setProdutor('');
            return;
        }

        if (produtor) {
            if (produtor.value) {
                if (produtor.value != value.value) {
                    setErroProdutor(false);
                    setProdutor(value);
                }
            } else {
                if (value.value) {
                    setErroProdutor(false);
                    setProdutor(value);
                }
            }
        } else {
            setErroProdutor(false);
            setProdutor(value);

        }
    }

    const addNewProdutor = () => {
        setShowModalAddProdutor(true);
    }

    const closeProdutorModal = () => {
        setShowModalAddProdutor(false);
    }

    const updateProdutor = () => {
        setShowModalAddProdutor(false);
        getProdutores(false);
    }

    const updateFazendas = () => {
        setShowModalAddFazenda(false);
        getFazendas(false);
    }

    const formatCpfCnpj = (value) => {
        if (!value) return "";
        
        const cleaned = value.replace(/\D/g, "");
        
        if (cleaned.length <= 11) {
            return cleaned.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4")
                .replace(/^(\d{3})(\d{3})(\d{3})$/, "$1.$2.$3")
                .replace(/^(\d{3})(\d{3})$/, "$1.$2")
                .replace(/^(\d{3})$/, "$1");
        } else {
            return cleaned.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5")
                .replace(/^(\d{2})(\d{3})(\d{3})(\d{4})$/, "$1.$2.$3/$4")
                .replace(/^(\d{2})(\d{3})(\d{3})$/, "$1.$2.$3")
                .replace(/^(\d{2})(\d{3})$/, "$1.$2")
                .replace(/^(\d{2})$/, "$1");
        }
    };
    
    const formatProdutores = (produtores) => {
        produtores = produtores.map(produtor => {
            const format = {
                value: produtor.id || produtor.agro_producer_id,
                label: `${produtor.id_externo && !isOmie() ? `${produtor.id_externo}: ` : ``}${(produtor.nome || produtor.nome_produtor) + (produtor.cpf_cnpj ? ` - CPF/CNPJ: ${formatCpfCnpj(produtor.cpf_cnpj)}` : '')}`,
                cpf_cnpj: produtor.cpf_cnpj
            };

            return format;
        });
        return produtores;
    };

    const formatProdutoresCfta = (produtores) => {
        produtores = produtores.map(produtor => {
            const format = {
                value: produtor.id || produtor.agro_producer_id,
                label: `${produtor.id_externo && !isOmie() ? `${produtor.id_externo}: ` : ``}${(produtor.nome || produtor.nome_produtor) + (produtor.cpf_cnpj ? ` - CPF/CNPJ: ${formatCpfCnpj(produtor.cpf_cnpj)}` : '')}`,
                cpf_cnpj: produtor.cpf_cnpj,
                estado: produtor.estado,
            };

            return format;
        });
        return produtores;
    };

    const getProdutores = async (existParams) => {
        setLoad(true);
        setDisabledProdutor(true);
        setLoadingProdutor(true);

        try {
            if (props.crea !== undefined && (props.crea.tipo === "crea" || props.crea.tipo === "visto")) {
            if (props.estado.value === 'RJ') {
                const response = await api.get(`/produtores/estado/${props.estado.value}`);
                let produtores = response.data.data;
                produtores = formatProdutores(produtores);

                if (!existParams) {
                    setProdutores(produtores);
                } else {
                    setProdutores(produtores);
                    changeProdutor(props.params.produtor);
                }

                setDisabledProdutor(false);
                setLoadingProdutor(false);

            } else {
                const response = await api.get(`/produtores/estado/${props.estado.value}`);
                let produtores = response.data.data;
                produtores = formatProdutores(produtores);

                // Verifica se há dados na resposta
                if (!response.data.data || response.data.data.length === 0) {
                    throw new Error("Nenhum produtor encontrado para este estado");
                }

                if (!existParams) {
                    setProdutores(produtores);
                } else {
                    setProdutores(produtores);
                    changeProdutor(props.params.produtor);
                }

                setDisabledProdutor(false);
                setLoadingProdutor(false);
            }

            } else {
                const payload = {
                    search: '',
                }

                const response = await api.post(`/produtores/search/${props.estado.value}?limit=20&offset=0`, payload);

                let produtores = response.data.data;
                produtores = formatProdutoresCfta(produtores);
                setProdutores(produtores);

                setDisabledProdutor(false);
                setErroProdutor(false);
                setLoadingProdutor(false);
            }
        } catch (e) {
            setProdutores([]);
            setDisabledProdutor(false);
            setErroProdutor(true);
            setLoadingProdutor(false);

            if (e.response) {
                setMsgErroProdutor(`${e.response.data.errors ? e.response.data.errors : "Não há produtores ou locais de aplicação cadastrados nesse estado."}`);
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(e, "ERRO-589 Não há produtores ou locais de aplicação cadastrados nesse estado - Tente novamente, se o erro persistir acione o suporte."),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 7000,
                        onScreen: true
                    }
                });
            } else {
                setMsgErroProdutor("Não há produtores ou locais de aplicação cadastrados nesse estado.");
                store.addNotification({
                    title: "Erro!",
                    message: "Não há produtores ou locais de aplicação cadastrados nesse estado.",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 7000,
                        onScreen: true
                    }
                });
            }
        }
    };

    const changeFazenda = (value) => {
        if (!value) {
            setErroFazenda(false);
            setFazenda('');
            return;
        }

        if (value !== fazenda) {
            setErroFazenda(false);
            setFazenda(value);
        }
    }

    const addNewFazenda = () => {
        setShowModalAddFazenda(true);
    }

    const formatFazendas = (fazendas) => {

        if (!Array.isArray(fazendas)) {
            return [];
        }

        return fazendas.map(fazenda => ({
            value: fazenda.id,
            label: fazenda.nome
        }));
    };

    const getFazendas = async (existParams) => {
        try {
            if (produtor.value) {
                setLoadingFazenda(true);
                setFazenda('');
                if (props.estado.value === 'RJ') {
                    const response = await api.get(`/fazendas/estado/${produtor.value}/${props.estado.value}`);
                    let fazendas = response.data.data;
                    fazendas = formatFazendas(fazendas);

                    if (!existParams) {
                        setFazendas(fazendas);
                    } else {
                        setFazendas(fazendas);
                        changeFazenda(props.params.fazenda);
                    }
                } else {
                    if (props.crea?.tipo === "crea") {
                        const response = await api.get(`/fazendas/${produtor.value}/${props.art.value}`);

                        let fazendas = response.data.data;
                        fazendas = formatFazendas(fazendas);

                        if (!existParams) {
                            setFazendas(fazendas);
                        } else {
                            setFazendas(fazendas);
                            changeFazenda(props.params.fazenda);
                        }
                    } else {
                        const response = await api.get(`/fazendas/estado/${produtor.value}/${props.estado.value}`);

                        let fazendas = response.data.data;
                        fazendas = formatFazendas(fazendas);

                        if (!existParams) {
                            setFazendas(fazendas);
                        } else {
                            setFazendas(fazendas);
                            changeFazenda(props.params.fazenda);
                        }
                    }
                }

                setDisabledFazenda(false);
                setErroFazenda(false);
                setLoadingFazenda(false);
            }
        } catch (e) {
            setFazendas([]);
            setDisabledFazenda(false);
            setErroFazenda(true);
            setMsgErroFazenda("Produtor não possui fazendas no estado selecionado.");
            setLoadingFazenda(false);

            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(e, "ERRO-590 Produtor não possui fazendas no estado selecionado - Tente novamente, se o erro persistir acione o suporte."),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    };

    const changeDevolucao = (value) => {
        if (value != devolucao) {
            setErroDevolucao(false);
            setDevolucao(value);
        }
    }

    const addNewDevolucao = () => {
        setShowModalAddDevolucao(true);
    }

    const closeDevolucaoModal = () => {
        setShowModalAddDevolucao(false);
    }

    const updateDevolucao = () => {
        setShowModalAddDevolucao(false);
        setDevolucao('');
        getDevolucoes(false);
        setErroDevolucao(false);
    }

    const formatDevolucoes = (devolucoes) => {
        devolucoes = devolucoes.map(devolucao => {
            const format = {
                value: devolucao.id,
                label: devolucao.nome
            };
            return format;
        });
        return devolucoes;
    };

    const getDevolucoes = async (existParams) => {
        try {
            setLoad(true);
            setLoadingDevolucao(true);
            const response = await api.get(`/devolucoes`);

            let devolucoes = response.data.data;
            devolucoes = formatDevolucoes(devolucoes);

            if (!existParams) {
                setDevolucoes(devolucoes);
            } else {
                setDevolucoes(devolucoes);
                changeDevolucao(props.params.devolucao);
            }

            setErroDevolucao(false);
            setDisabledDevolucao(false);
            setLoadingDevolucao(false);
          
        } catch (e) {
            if (props.estado.value === "SP") {
                setDevolucoes([]);
                setLoadingDevolucao(false);
            } else {
                setDevolucoes([]);
                setDisabledDevolucao(false);
                setErroDevolucao(true);
                setMsgErroDevolucao("Não há locais de devolução cadastrados nesse estado.");
                setLoadingDevolucao(false);

                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(e, "ERRO-591 Não há locais de devolução cadastrados nesse estado - Tente novamente, se o erro persistir acione o suporte."),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
            }
        }
    };

    const validaFazendas = async () => {
        if (showModalFazendaRef.current) {
            return;
        }

        if (!fazenda || !fazenda.value) {
            setShowModalFarmCoords(false);
            return;
        }

        const validationId = farmCoordsValidationRef.current + 1;
        farmCoordsValidationRef.current = validationId;

        try {
            const response = await api.get(`/fazendas/${fazenda.value}`);
            if (farmCoordsValidationRef.current !== validationId) return;
            if (showModalFazendaRef.current) return;

            const farm = response?.data?.data || {};
            const latitude = farm.latitude;
            const longitude = farm.longitude;

            const hasCoords =
                latitude !== null &&
                latitude !== undefined &&
                latitude !== '' &&
                longitude !== null &&
                longitude !== undefined &&
                longitude !== '';

            setShowModalFarmCoords(!hasCoords);
        } catch (_) {
            if (farmCoordsValidationRef.current !== validationId) return;
            if (showModalFazendaRef.current) return;
            setShowModalFarmCoords(true);
        }
    }

    const [offset, setOffset] = useState(20);
    const [hasMoreProdutores, setHasMoreProdutores] = useState(true);

    const fetchMaisProdutores = async () => {
        if (!hasMoreProdutores) return;

        const payload = { search: '' };
        const response = await api.post(`/produtores/search/${props.estado.value}?limit=20&offset=${offset}`, payload);

        const novos = formatProdutoresCfta(response.data.data);

        if (!novos || novos.length === 0) {
            setHasMoreProdutores(false);
            return;
        }

        setProdutores(prev => [...prev, ...novos]);
        setOffset(offset + 20);
    };

    useEffect(() => {

        if (load === false) {
            if (props.params) {
                if (Array.isArray(props.params) && props.params.length === 0) {
                    setExistParams(false);
                    getProdutores(false);
                    getDevolucoes(false);

                } else if (props.params.produtor || props.params.fazenda || props.params.devolucao) {
                    setExistParams(true);
                    getProdutores(true);
                    getDevolucoes(true);
                } else {
                    setExistParams(false);
                    getProdutores(false);
                    getDevolucoes(false);
                }
            } else {
                setExistParams(false);
                getProdutores(false);
                getDevolucoes(false);
            }
        }
    }, []);

    useEffect(() => {
        validaFazendas();
    }, [fazenda]);

    useEffect(() => {
        showModalFazendaRef.current = showModalFazenda;

        if (showModalFazenda) {
            farmCoordsValidationRef.current = farmCoordsValidationRef.current + 1;
            setShowModalFarmCoords(false);
        }

        if (!showModalFazenda && pendingFarmCoordsRecheckAfterEditRef.current) {
            pendingFarmCoordsRecheckAfterEditRef.current = false;
            validaFazendas();
        }
    }, [showModalFazenda]);

    useEffect(() => {
        if (isFirstEstadoRender.current) {
            isFirstEstadoRender.current = false;
            return;
        }
        if (!props.estado?.value) return;

        setOffset(20);
        setHasMoreProdutores(true);
        changeProdutor('');
        setFazenda('');
        setProdutores([]);
        getDevolucoes(false);
        getProdutores(false);
    }, [props.estado?.value]);

    useEffect(() => {
        if (produtor.value) {
            getFazendas(existParams);
        }
    }, [produtor]);

    useEffect(() => {
        props.update({ produtor, fazenda, devolucao, erroProdutor, erroFazenda, erroDevolucao })
    }, [produtor, fazenda, devolucao, erroProdutor, erroFazenda, erroDevolucao])

    useEffect(() => {
        if (produtor.value === '' || produtor === '') {
            setFazenda('');
        }
    }, [produtor]);

    // Prefill Produtor a partir do draft (dataItemRecipe)
    useEffect(() => {
        const draft = props.recipeDraft;
        const produtoresLoaded = Array.isArray(produtores) && produtores.length > 0;
        const canPrefill = draft && produtoresLoaded && !prefillOnce.current.produtor && (!produtor || produtor === '' || produtor.value === '' || produtor.value === undefined);
        if (!canPrefill) return;

        const draftProducerId = draft.agro_producer_id;
        const draftProducerName = (draft.produtor_nome || '').toLowerCase().trim();

        let option = null;
        if (draftProducerId) {
            option = produtores.find(p => String(p.value) === String(draftProducerId));
        }
        if (!option && draftProducerName) {
            option = produtores.find(p => (p.label || '').toLowerCase().startsWith(draftProducerName));
        }

        if (option) {
            localStorage.setItem("saveOptionProducerDraft", JSON.stringify(option));
        } else{
        }

        // O produtor guardado no navegador só vale se for o do rascunho atual. Ele sobrevive a
        // F5/aba fechada/outra aba (o localStorage é compartilhado), então pode ser o produtor
        // de uma emissão anterior - usá-lo aqui emitia a receita no nome do produtor errado
        // quando o do rascunho não estava na primeira página da lista.
        let optionSaved = null;
        try {
            optionSaved = JSON.parse(localStorage.getItem("saveOptionProducerDraft"));
        } catch (e) {
            optionSaved = null;
        }
        const savedIsFromDraft = !!optionSaved && (
            draftProducerId
                ? String(optionSaved.value) === String(draftProducerId)
                : !!draftProducerName && (optionSaved.label || '').toLowerCase().startsWith(draftProducerName)
        );
        const optionFromCurrentList = (savedIsFromDraft && Array.isArray(produtores))
            ? produtores.find(p => String(p.value) === String(optionSaved.value))
            : null;

        const resolvedOption = option || optionFromCurrentList || (savedIsFromDraft ? optionSaved : null);

        if (resolvedOption) {
            const existsInOptions = Array.isArray(produtores)
                ? produtores.some(p => String(p.value) === String(resolvedOption.value))
                : false;
            if (!existsInOptions) {
                setProdutores((prev) => {
                    const safePrev = Array.isArray(prev) ? prev : [];
                    const alreadyExists = safePrev.some(p => String(p.value) === String(resolvedOption.value));
                    return alreadyExists ? safePrev : [resolvedOption, ...safePrev];
                });
            }
            changeProdutor(resolvedOption);
            prefillOnce.current.produtor = true;
            return;
        }

        // Produtor do rascunho não está entre os primeiros produtores carregados (busca
        // paginada limit=20) nem bateu por nome - busca ele direto por ID em vez de deixar
        // o campo vazio (bug real: rascunho de pedido com produtor "fora da primeira
        // página" nunca pré-selecionava).
        if (draftProducerId) {
            prefillOnce.current.produtor = true;
            api.get(`/produtores/${draftProducerId}`).then((response) => {
                const p = response?.data?.data;
                if (!p) return;
                const fetchedOption = {
                    value: p.id,
                    label: `${p.nome}${p.cpf_cnpj ? ` - CPF/CNPJ: ${formatCpfCnpj(p.cpf_cnpj)}` : ''}`,
                    cpf_cnpj: p.cpf_cnpj,
                    estado: p.estado,
                };
                localStorage.setItem("saveOptionProducerDraft", JSON.stringify(fetchedOption));
                setProdutores((prev) => {
                    const safePrev = Array.isArray(prev) ? prev : [];
                    const alreadyExists = safePrev.some(x => String(x.value) === String(fetchedOption.value));
                    return alreadyExists ? safePrev : [fetchedOption, ...safePrev];
                });
                changeProdutor(fetchedOption);
            }).catch(() => {});
        }
    }, [produtores, props.recipeDraft]);

    // Prefill Fazenda após carregar fazendas do produtor selecionado
    useEffect(() => {
        const draft = props.recipeDraft;
        const fazendasLoaded = Array.isArray(fazendas) && fazendas.length > 0;
        const canPrefill = draft && fazendasLoaded && !prefillOnce.current.fazenda && (!fazenda || fazenda === '' || fazenda.value === '' || fazenda.value === undefined);
        if (!canPrefill) return;

        const draftFarmId = draft.agro_farm_id;
        const draftFarmName = (draft.local_aplicacao_nome || '').toLowerCase().trim();

        let option = null;
        if (draftFarmId) {
            option = fazendas.find(f => f.value === draftFarmId);
        }
        if (!option && draftFarmName) {
            option = fazendas.find(f => (f.label || '').toLowerCase() === draftFarmName);
        }

        if (option) {
            changeFazenda(option);
            prefillOnce.current.fazenda = true;
        }
    }, [fazendas, props.recipeDraft]);

    // Prefill Devolução quando opções carregarem
    useEffect(() => {
        // console.log("props.recipeDraft", props.recipeDraft)
        const draft = props.recipeDraft;
        const devolucoesLoaded = Array.isArray(devolucoes) && devolucoes.length > 0;
        const canPrefill = draft && devolucoesLoaded && !prefillOnce.current.devolucao && (!devolucao || devolucao === '' || devolucao.value === '' || devolucao.value === undefined);
        if (!canPrefill) return;

        const draftDevolutionId = draft.agro_devolution_id;
        const draftDevolutionName = (draft.devolucao_nome || '').toLowerCase().trim();

        let option = null;
        if (draftDevolutionId) {
            option = devolucoes.find(d => d.value === draftDevolutionId);
        }
        if (!option && draftDevolutionName) {
            option = devolucoes.find(d => (d.label || '').toLowerCase() === draftDevolutionName);
        }

        if (option) {
            changeDevolucao(option);
            prefillOnce.current.devolucao = true;
        }
    }, [devolucoes, props.recipeDraft]);



    return (
        <S.ContainerGeral>
            <SelectV2Multi
                height='auto'
                marginBottom={msgErroProdutor ? "10px" : "24px"}
                name='produtor'
                className="select"
                label="Produtor"
                labelWithAsterisk={true}
                id='produtor'
                value={produtor ? produtor.value : ""}
                disabled={hasRecipeDraft ? true : disabledProdutor}
                loading={loadingProdutor}
                erro={erroProdutor}
                onChange={(e) => {
                    changeProdutor(e);
                    persistProdutorFazenda(e, null);
                }}
                options={produtores}
                estadoValue={props.estado.value}
                selectUniqueOption={existParams ? produtores.length === 1 ? true : false : true}
                buttonAddNew={true}
                onClickAddNew={() => addNewProdutor()}
                messageErro={msgErroProdutor}
                isModal={true}
                isClearable={true}
                onMenuScrollToBottom={() => {
                    fetchMaisProdutores();
                }}
                InputFontWeight={700}
                isTotvs={isTotvs() && !isOmie()}
            />

            <SelectV2
                height='auto'
                marginBottom={msgErroFazenda ? "10px" : "24px"}
                name='fazenda'
                className="select"
                label="Propriedade Rural"
                labelWithAsterisk={true}
                id='fazenda'
                value={fazenda ? fazenda.value : ""}
                disabled={hasRecipeDraft ? true : disabledFazenda}
                loading={loadingFazenda}
                erro={erroFazenda}
                onChange={(e) => {
                    changeFazenda(e);
                    persistProdutorFazenda(produtor, e);
                }}
                options={fazendas}
                selectUniqueOption={existParams ? fazendas.length === 1 ? true : false : true}
                buttonAddNew={produtor.value ? true : false}
                onClickAddNew={() => addNewFazenda()}
                messageErro={msgErroFazenda}
                isTotvs={isTotvs() && !isOmie()}
            />

            {props.estado.value === "SP" ? (
                <SelectV2
                    height='auto'
                    marginBottom="24px"
                    name='devolucao'
                    className="select"
                    label="Local de devolução"
                    labelWithAsterisk={false}
                    id='devolucao'
                    value={devolucao.value || devolucao}
                    disabled={(hasRecipeDraft && !isOmie()) ? true : disabledDevolucao}
                    loading={loadingDevolucao}
                    erro={erroDevolucao}
                    onChange={(e) => changeDevolucao(e)}
                    options={devolucoes}
                    selectUniqueOption={true}
                    buttonAddNew={hasRecipeDraft ? isOmie() : true}
                    onClickAddNew={() => addNewDevolucao()}
                    messageErro={msgErroDevolucao}
                    isModal={true}
                    estado={props.estado}
                    buttonDelete={true}
                />
            ) : (
                <SelectV2
                    height='auto'
                    marginBottom="24px"
                    name='devolucao'
                    className="select"
                    label="Local de devolução"
                    labelWithAsterisk={true}
                    id='devolucao'
                    value={devolucao.value || devolucao}
                    disabled={(hasRecipeDraft && !isOmie()) ? true : disabledDevolucao}
                    loading={loadingDevolucao}
                    erro={erroDevolucao}
                    onChange={(e) => changeDevolucao(e)}
                    options={devolucoes}
                    selectUniqueOption={!existParams}
                    buttonAddNew={hasRecipeDraft ? isOmie() : true}
                    onClickAddNew={() => addNewDevolucao()}
                    messageErro={msgErroDevolucao}
                    isModal={true}
                />
            )}

            <S.ContainerFooter>
                <Footer>
                    <img className="pin" src={Pin} alt='estado' />

                    <TaglineP color={theme.colors.gray.Cinza_2} fontWeight={800}>
                        Exibindo resultados para {props.estado.label}
                    </TaglineP>
                </Footer>
            </S.ContainerFooter>

            {showModalAddProdutor ? (
                <Modal
                    size='lg'
                    show={showModalAddProdutor}
                    onHide={() => closeProdutorModal()}
                >
                    <AddProdutor isModal={true} update={() => updateProdutor()} autoOpenFarmAfterCreate={true} />
                </Modal>
            ) : (null)}

            {showModalAddFazenda ? (
                <Modal
                    size='lg'
                    show={showModalAddFazenda}
                    onHide={() => setShowModalAddFazenda(false)}
                >
                    <AddFazenda
                        isModal={true}
                        update={() => updateFazendas()}
                        match={{
                            params: {
                                id: produtor.value
                            }
                        }}
                    />
                </Modal>
            ) : (null)}

            {showModalFazenda ? (
                <Modal
                    size='lg'
                    show={showModalFazenda}
                    onHide={() => { setFazenda(""); setShowModalFazenda(false) }}
                >
                    <EditLocal
                        idFazenda={fazenda.value || fazenda}
                        idProdutor={produtor.value || produtor}
                        isModal={true}
                        openModal={(e) => setShowModalFazenda(e)}
                    />
                </Modal>
            ) : (null)}

            {showModalAddDevolucao ? (
                <Modal
                    size='lg'
                    show={showModalAddDevolucao}
                    onHide={() => closeDevolucaoModal()}
                >
                    <AddDevolucao isModal={true} update={() => updateDevolucao()} />
                </Modal>
            ) : (null)}

            {showModalFarmCoords ? (
                <ModalFarmCoords
                    show={showModalFarmCoords}
                    blocking={true}
                    farmId={fazenda?.value || null}
                    onHide={() => setShowModalFarmCoords(false)}
                    onEditFarmCoords={() => {
                        pendingFarmCoordsRecheckAfterEditRef.current = true;
                        farmCoordsValidationRef.current = farmCoordsValidationRef.current + 1;
                        setShowModalFarmCoords(false);
                        setShowModalFazenda(true);
                    }}
                    onCompleted={(e) => {
                        if (e?.action === 'geocode') {
                            validaFazendas();
                        }
                    }}
                />
            ) : null}

            {showModalAddContrato && (
                <Modal
                    size='lg'
                    show={showModalAddContrato}
                    onHide={() => setShowModalAddContrato(false)}
                >
                    <h4 style={{ textAlign: 'center' }} >Cadastrar contrato</h4>
                    <Contracts
                        estado={props.estado}
                        agronomo={props.responsavel.value}
                        art={props.art}
                        numeroArt={props.art.value}
                        isModal={true}
                        update={() => updateModalAddContrato()}
                        onContractSaved={() => getProdutores(false)}
                    />
                </Modal>
            )}
        </S.ContainerGeral>
    )
}

export default FormLocalAplicacao;
